export default __webpack_public_path__ + "static/Logo_fissuration-441418842058fbef8b2f7ae773333c56.png";